import * as React from "react";
import {WalletService, WALLET_SERVICE_NAME, WalletBalanceResult} from "../../../service/admin/WalletService";
import {AppCtx} from "../../../ioc/ApplicationContext";
import {UserLinkPanel} from "../../user/UserLinkPanel";
import {Symbols} from "../../../ioc/Symbols";
import {TransactionHistoryList} from "./TransactionHistoryList";
import {TransactionHistoryService} from "../../../service/admin/TransactionHistoryService";
import {USER_SERVICE_NAME, UserService} from "../../../service/admin/UserService";


interface State {
    pokUserId?: string | number;
    balance?: WalletBalanceResult;
}

export class WalletView extends React.Component<{ params: { cubeiaId: string, walletAccountCode: string } }, State> {

    walletService: WalletService;
    transactionHistoryService: TransactionHistoryService;
    userService: UserService;

    constructor(props) {
        super(props);
        this.walletService = AppCtx.resolve<WalletService>(WALLET_SERVICE_NAME);
        this.transactionHistoryService = AppCtx.resolve<TransactionHistoryService>(Symbols.TransactionHistoryService);
        this.userService = AppCtx.resolve<UserService>(USER_SERVICE_NAME)

        this.state = {};
    }

    componentDidMount() {
        this.userService.getEntity(this.props.params.cubeiaId).then(res => {
            var pokUserId = res.externalUserId;
            this.setState({pokUserId});
            return pokUserId;
        }).then(pokUserId => {
            this.walletService.getBalanceV2(pokUserId, this.props.params.walletAccountCode).then(balance => {
                this.setState({balance})
            });
        });
    }


    getDateTime(timestamp: number) {
        if (timestamp < 2) {
            return "";
        }
        var date = new Date(timestamp);
        return date.toLocaleString();
    }

    render() {
        var currencyCode = getCurrencyCodeFromAccountType(this.props.params.walletAccountCode);

        if (this.state.balance == null) {
            return <div></div>;
        }
        return (
            <div>
                <div className="row wrapper border-bottom white-bg page-heading">
                    <div className="col-lg-12">
                        <h1>Account</h1>
                    </div>
                </div>

                <div className="wrapper wrapper-content animated fadeInRight">

                    <div className="row">

                    </div>

                    <div className="row">
                        <div className="col-lg-6">
                            <div className="row">
                                <div className="col-lg-6">
                                    <UserLinkPanel userId={this.props.params.cubeiaId} header="Account Owner"/>
                                </div>

                                <div className="col-lg-6">
                                    <div className="ibox float-e-margins">
                                        <div className="ibox-title">
                                            <span
                                                className="label label-success pull-right">{currencyCode}</span>
                                            <h5>Balance</h5>
                                        </div>
                                        <div className="ibox-content">
                                            <h1 className="no-margins">{this.state.balance.walletBalance + " " + currencyCode}</h1>
                                            <small className="text-muted">
                                                {isVaultAccount(currencyCode) ? "VAULT" : "MAIN"}
                                            </small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <TransactionHistoryList userId={this.state.pokUserId}
                                                    accountType={this.props.params.walletAccountCode}
                                                    service={this.transactionHistoryService}/>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

function getCurrencyCodeFromAccountType(walletAccountType: string): string {
    switch (walletAccountType) {
        case 'sc-main': return 'XSD';
        case 'gc-main': return 'XGC';
        case 'sc-vault': return 'VAULT-SC';
        case 'gc-vault': return 'VAULT-GC';
        default: return 'UNK';
    }
}

function isVaultAccount(currencyCode: string) {
    return currencyCode === 'SC-VLT' || currencyCode === 'GC-VLT';
}



// WEBPACK FOOTER //
// ./src/app/ui/view/account/WalletView.tsx